import { Helmet } from "react-helmet-async";

const SITE_ORIGIN = "https://mersaakademi.com";

export type SeoProps = {
  title: string;
  description: string;
  path?: string;
  noindex?: boolean;
};

const canonicalUrl = (path: string) => {
  if (path === "/") return `${SITE_ORIGIN}/`;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_ORIGIN}${normalized.replace(/\/+$/, "")}`;
};

export default function Seo({ title, description, path, noindex = false }: SeoProps) {
  const canonical = path != null ? canonicalUrl(path) : undefined;

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="google-site-verification" content="DgSIOiTzfm5TqbkHYsxjQHBGojvy26DrWpUQuWWobkw" />
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={canonical} />}
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:site_name" content="Mersa Akademi" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
